import CloseIcon from '@mui/icons-material/Close';
import {
    DialogActions,
    DialogContent,
    DialogTitle,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { addUserRoster } from '../../../axios/RosterItem/RosterItemApi';
import { ControlpanelPrimaryButton, ControlpanelSecondaryButton, GrayIconButton } from '../../../components/StyledButton';
import { CustomDialog } from '../../../components/StyledComponents';
import { useLoading } from '../../../context/LoadingContext';
import { useSettings } from '../../../context/SettingsContext';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SaveIcon from '@mui/icons-material/Save';
import CustomSelectRosterSelectUser from '../../../components/CustomSelectRosterSelectUser';
import CustomSelectRosterSelectGroup from '../../../components/CustomSelectRosterSelectGroup';


const AddUserRoster = ({ allUser, onClose, onRefresh, selectedRows, usersData, GroupData }) => {
    const { t } = useTranslation();
    const { settings } = useSettings();
    const [show, hide] = useLoading();



    const initialFormData = {
        // shift: null,
        userId: [],
        groupId: []
        // day: '',
        // week: null,
        // rosterId: '',
        // username: ''
    };


    const [formData, setFormData] = useState(initialFormData);




    const handleDataChange = (name, newData) => {

        setFormData((prevData) => ({
            ...prevData,
            [name]: newData,
        }));

    };
    const handleCloseDialog = () => {

        onClose();
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData((prevData) => {
            if (name === 'user') {
                return {
                    ...prevData,
                    userId: value,
                };
            } else if (name === 'group') {
                return {
                    ...prevData,
                    groupId: value,
                };
            } else {
                return {
                    ...prevData,
                    [name]: value,
                };
            }
        });
    };

    useEffect(() => {
        const preselected = usersData.map(u => u.userId);
        setFormData(prev => ({ ...prev, userId: preselected }));
    }, [usersData]);

    useEffect(() => {
        const preselectedGroup = usersData.map(u => u.groupId);
        setFormData(prev => ({ ...prev, groupId: preselectedGroup }));
    }, [usersData]);



    const handleRemoveUser = (removedUserId) => {
        setFormData((prevData) => ({
            ...prevData,
            userId: prevData.userId.filter(id => id !== removedUserId),
        }));
    };
    const handleRemoveGroup = (removedGroupId) => {
        setFormData((prevData) => ({
            ...prevData,
            groupId: prevData.groupId.filter(id => id !== removedGroupId),
        }));
    };


    const handleSubmit = async (e) => {

        const payload = {
            rosterId: selectedRows.rosterId,
            userIds: formData.userId.filter(id => id).join(','),
            groupIds: formData.groupId.filter(id => id).join(','),
            langId: localStorage.getItem("i18nextLngId")
        };

        try {
            const response = await addUserRoster(payload);
            console.error('There was an error creating the leave!', response);

            if (response.data.message === 'Successful' || response.data.message === 'Thành công') {
                handleCloseDialog();
                toast.success(t('common.added-user-to-roster-successfully'));
                onRefresh();
                // onRefreshAddUserRoster()
            } else {
                const jsonObject = JSON.parse(response.data.message);
                toast.error(jsonObject.message);
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status !== 401) {
                    toast.error(t(error?.response.data));
                }
            }
        } finally {
            hide();
        }
    };

    return (
        <CustomDialog maxWidth={'sm'} open onClose={handleCloseDialog} keepMounted>
            <DialogTitle>
                <div className='flex justify-between'>
                    <div className='flex items-center gap-4'>
                        <p className='text-xl font-semibold '>
                            {/* {t('common.roster-items')} - {selectedItem?.startDate ? format(selectedItem?.startDate, settings.dateFormat) : selectedRows.formatStartDate} */}

                            {t('button.add-more-users')}
                        </p>
                    </div>
                    <GrayIconButton onClick={handleCloseDialog}>
                        <CloseIcon />
                    </GrayIconButton>
                </div>
            </DialogTitle>
            <DialogContent data-tour="shift-and-roster-add-user-input">
                <div
                  className='grid grid-cols-2 gap-x-10 gap-y-3 relative mt-2'
                  
                >

                    <div className='col-span-2 pt-2'>
                        <label className='block text-sm mb-1 z-10 relative bg-white pr-2'>
                            {t('common.select-group')}

                        </label>
                        <div className='mt-2 relative'>
                            <CustomSelectRosterSelectGroup
                                multiple={true}
                                name="group"
                                value={formData.groupId}
                                onChange={handleInputChange}
                                options={GroupData}
                                dataType="group"
                                onRemoveItem={handleRemoveGroup}
                            />
                            <div className="absolute inset-y-0 right-3 flex items-center pointer-events-none">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-4 w-4 text-gray-500"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M5.23 7.21a.75.75 0 011.06.02L10 11.584l3.71-4.355a.75.75 0 111.14.976l-4.25 5a.75.75 0 01-1.14 0l-4.25-5a.75.75 0 01.02-1.06z"
                                        clipRule="evenodd"
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='grid grid-cols-2 gap-x-10 gap-y-3 relative mt-2'>

                    <div className='col-span-2 pt-2'>
                        <label className='block text-sm mb-1 z-10 relative bg-white pr-2'>
                            {t('common.select-user')}

                        </label>
                        <div className='mt-2 relative'>
                            <CustomSelectRosterSelectUser
                                multiple={true}
                                name="user"
                                value={formData.userId}
                                onChange={handleInputChange}
                                options={allUser}
                                dataType="user"
                                onRemoveItem={handleRemoveUser}
                            />
                            <div
                                className={`absolute inset-y-0 right-3 flex items-center pointer-events-none ${Array.isArray(formData.userId) && formData.userId.length > 2 ? 'hidden' : ''
                                    }`}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-4 w-4 text-gray-500"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M5.23 7.21a.75.75 0 011.06.02L10 11.584l3.71-4.355a.75.75 0 111.14.976l-4.25 5a.75.75 0 01-1.14 0l-4.25-5a.75.75 0 01.02-1.06z"
                                        clipRule="evenodd"
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <div className='flex gap-2 px-4 py-4'>

                    <ControlpanelSecondaryButton onClick={handleCloseDialog}>
                        <p>{t('button.cancel')}</p>
                    </ControlpanelSecondaryButton>
                    <ControlpanelPrimaryButton onClick={handleSubmit} sx={{
                        textDecoration: 'none'
                    }}>
                        <p>{t('button.save')}</p>
                    </ControlpanelPrimaryButton>
                </div>
            </DialogActions>
        </CustomDialog >
    );
};

export default AddUserRoster;
